{ ActionHistory } = require '@trello/action-history'
{ getFeedback } = require 'app/scripts/views/suggestions-feedback/get-feedback'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
template = require 'app/scripts/views/templates/checklist_add_menu'
{ track, trackDebounced } = require '@trello/analytics'
ModelCache = require 'app/scripts/db/model-cache'

alphabeticallyOn = (field) -> (a, b) -> a.get(field).localeCompare b.get(field)
defaultChecklistName = l(['templates', 'checklist_add_menu', 'default-checklist-name'])

MAX_SUGGESTIONS = 3

module.exports = class AddChecklistMenu extends View
  viewTitleKey: 'add checklist'

  initialize: ({ @cardView }) ->

  events:
    'click .js-add-checklist': 'submit'
    'submit form': 'submit'
    'change .js-checklist-copy-source': 'changeSource'
    'input .js-checklist-title': (e) ->
      @$('.js-checklist-title').attr('data-changed', true)
    'click .js-suggested-actions-feedback': getFeedback('Add Checklist')
    'click .js-suggested-checklist': 'suggestedChecklist'

  _canAddChecklist: (model, limitType) ->
    !model.isOverLimit('checklists', limitType)

  render: ->
    checklistCards = @modelCache.find 'Card', (card) =>
      card.get('idBoard') == @model.getBoard().id &&
      card.isOpen() &&
      card.checklistList.length > 0
    .sort alphabeticallyOn('name')
    .map (card) ->
      name: card.get('name')
      checklists: card.checklistList.chain()
        .clone()
        .sort alphabeticallyOn('name')
        .map (checklist) ->
          id: checklist.id
          name: checklist.get('name')
        .value()

    suggestions = @getSuggestedChecklists()
    @$el.html template({
      checklistCards,
      suggestions,
      canAddChecklistCard: @_canAddChecklist(@model, 'perCard'),
      canAddChecklistBoard: @_canAddChecklist(@model.getBoard(), 'perBoard')
    })

    if suggestions.length > 0
      trackDebounced.hour("Suggestions", "Card Checklist Menu", "Displayed", suggestions.length)

    @

  getSuggestedChecklists: ->
    history = ActionHistory.get()

    idList = @model.get('idList')

    suggested = new Set()

    history.filter ({ action, context }) ->
      action.type == 'add-checklist' &&
      # Only add checklists we've added to other cards in this list
      context.idList == idList &&
      action.idChecklistSource &&
      action.name &&
      action.name != defaultChecklistName
    .filter ({ action }) ->
      if suggested.has(action.idChecklistSource)
        false
      else
        suggested.add(action.idChecklistSource)
        true
    .filter ({ action }) => @model.isValidSuggestion(action)
    .slice(0, MAX_SUGGESTIONS)
    .map ({ action }) ->
      id: action.idChecklistSource,
      name: action.name

  addChecklist: (idChecklistSource, title, fromSuggestion) ->
    if !(@_canAddChecklist(@model, 'perCard') &&
    @_canAddChecklist(@model.getBoard(), 'perBoard'))
      @render()
      return

    if fromSuggestion
      track("Card", "Suggested", "Add Checklist")
    else
      if idChecklistSource != ""
        copiedText = "Copied Checklist Items"
      else
        copiedText = "No Checklist Items Copied"

      if title == defaultChecklistName
        gaActionText = "Default Title (Checklist), #{copiedText}"
      else
        gaActionText = "Renamed Title, #{copiedText}"

      track("Checklist", "Create", "#{gaActionText}")

    @model.recordAction
      type: 'add-checklist'
      idChecklistSource: idChecklistSource || undefined
      name:
        if title == defaultChecklistName
          undefined
        else
          title

    checklist = @model.checklistList.create
      name: title
      idChecklistSource: idChecklistSource
      idCard: @model.id
    ,
      error: =>
        # The checklist is optimisitically added.
        # If the add fails, remove the checklist
        @model.checklistList.remove(checklist)

    @cardView.focusChecklistAdd(checklist)

  suggestedChecklist: (e) ->
    $target = @$(e.currentTarget)

    idChecklistSource = $target.attr('data-id')
    name = $target.attr('data-name')

    @addChecklist(idChecklistSource, name, true)

    PopOver.hide()
    return

  submit: (e) ->
    Util.stop(e)

    title = @$('.js-checklist-title').val()
    idChecklistSource = @$('.js-checklist-copy-source').val()

    if title.length == 0
      @$('.js-checklist-title').focus().select()
      return

    @addChecklist(idChecklistSource, title, false)

    PopOver.hide()

    return

  changeSource: (e) ->
    $checklistTitle = @$('.js-checklist-title')
    defaultName = $checklistTitle.attr('data-default')

    # If they've modified it to something other than the default/blank don't overwrite their input
    if $checklistTitle.attr('data-changed') && $checklistTitle.val() && $checklistTitle.val() != defaultName
      return

    idChecklistSource = @$('.js-checklist-copy-source').val()
    newName =
      if idChecklistSource && (sourceChecklist = ModelCache.get('Checklist', idChecklistSource))?
        sourceChecklist.get('name')
      else
        defaultName

    $checklistTitle.val(newName).removeAttr('data-changed')
